import { Component, Mixins } from 'vue-property-decorator';
import HybridMixin from '@rogues/shared/mixins/hybrid';
import { get } from 'lodash/object';
import Props from './props';

@Component({
    components: {},
})

/**
 * @name PageHead
 */
export default class PageHead extends Mixins(Props, HybridMixin) {
    /**
     * Return the Background
     *
     * @returns {object}
     */
    get pageHeadStyle(): object {
        const style: { [k: string]: string } = {};
        if (this.getValue('img')) {
            style.backgroundImage = `url(${get(this.getValue('img'), `versions.${this.getValue('imageVersion')}`, this.getValue('img').link)})`;
        } else {
            style.backgroundColor = this.getValue('bgColor');
        }
        style.height = this.getValue('height');
        return {
            ...style,
        };
    }
}
